module.exports = __webpack_public_path__ + "img/banco.e2cbcb00.svg";